import Strings from "src/shared/Strings";
export class ComponentType {
    constructor(response) {
        this.type = response.name;
        this.parent = response.parent;
        this.display_name = response.display_name;
        this.schema = response.schema;
        this.created_date = response.created_date;
        this.updated_date = response.updated_date;
    }
    getDisplayName() {
        return this.display_name || Strings.capitalize(this.type);
    }
}
